import { productTypes } from '@src/cart/cartProductTypes';
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from 'semantic-ui-react';
import { Box, Button, Flex } from 'theme-ui';
type LineItem = {
  id: string;
  vm: any;
  onRemove: any;
  type: string;
};
const LineItem = ({ id, vm, onRemove, type }: LineItem) => {
  const { t, i18n } = useTranslation();
  const [loadingRemove, setLoadingRemove] = useState();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: ['column', null, null, 'row'],
        backgroundColor: vm.bgColor || '#f8f8f8',
        padding: '24px',
        borderRadius: '10px',
        gap: ['12px', '24px', null, '48px'],
        marginBottom: '30px',
      }}
    >
      <Flex sx={{ gap: '20px' }}>
        <Flex
          sx={{
            size: '76px',
            flexShrink: 0,
            borderRadius: '50%',
            overflow: 'hidden',
          }}
        >
          <StaticImage
            src="../../../src/assets/lesson-default-image.jpg"
            alt=""
          />

          {vm?.featuredImageUrl && (
            <GatsbyImage
              sx={{ width: '100%', objectFit: 'cover' }}
              src={vm.featuredImageUrl}
              alt=""
            />
          )}
        </Flex>

        <div>
          <Box
            sx={{
              color: type === productTypes.lesson.type ? 'text' : '#707070',
              '&:before': {
                content: '""',
                lineHeight: '1em',
                display: 'inline-block',
              },
            }}
          >
            {vm.authorTitle}
          </Box>

          <Box
            sx={{
              color: type === productTypes.lesson.type ? '#707070' : 'text',
              '&:before': {
                content: '""',
                lineHeight: '1em',
                display: 'inline-block',
              },
            }}
          >
            {vm.topicLine1}
          </Box>

          <Box
            sx={{
              color: type === productTypes.lesson.type ? '#707070' : 'text',
              '&:before': {
                content: '""',
                lineHeight: '1em',
                display: 'inline-block',
              },
            }}
          >
            {vm.topicLine2}
          </Box>

          <Box
            sx={{
              color: type === productTypes.lesson.type ? '#707070' : 'text',
              '&:before': {
                content: '""',
                lineHeight: '1em',
                display: 'inline-block',
              },
            }}
          >
            {vm.topicLine3}
          </Box>

          <Box
            sx={{
              color: type === productTypes.lesson.type ? '#707070' : 'text',
              '&:before': {
                content: '""',
                lineHeight: '1em',
                display: 'inline-block',
              },
            }}
          >
            {vm.topicLine4}
          </Box>
        </div>
      </Flex>

      <Box sx={{ marginLeft: ['0', null, null, 'auto'] }}>
        <Box
          sx={{
            color: type === productTypes.lesson.type ? 'text' : '#707070',
            '&:before': {
              content: '""',
              lineHeight: '1em',
              display: 'inline-block',
            },
          }}
        >
          {vm.summaryLine1}
        </Box>
        <Box
          sx={{
            '&:before': {
              content: '""',
              lineHeight: '1em',
              display: 'inline-block',
            },
          }}
        >
          {vm.summaryLine2}
        </Box>
        <Box
          sx={{
            '&:before': {
              content: '""',
              lineHeight: '1em',
              display: 'inline-block',
            },
          }}
        >
          {' '}
        </Box>
        <div>
          <span sx={{ color: 'primary' }}>{vm.price}</span>
          <span sx={{ color: '#707070' }}>{vm.discount}</span>
        </div>
      </Box>

      <Flex sx={{ alignItems: 'end', justifyContent: 'end' }}>
        <Button
          sx={{ color: 'primary' }}
          variant="empty"
          onClick={() => {
            setLoadingRemove(true);
            onRemove(id, setLoadingRemove);
          }}
        >
          <div sx={{ width: '3rem' }}>
            {loadingRemove && <Loader inline active size="small" />}
            {!loadingRemove && t('remove')}
          </div>
        </Button>
      </Flex>
    </Box>
  );
};

export default LineItem;
